// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___22pn-","input":"styles__input___1PoZl","createNewButton":"styles__createNewButton___3Pfkc","label":"styles__label___2OpTL"};